import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * @typedef {import('classes/aircraft').Aircraft} Aircraft
 */

/**
 * A custom React hook that retrieves a specific aircraft from the Redux store based on its unique identifier.
 *
 * @function useAircraft
 * @param {string} ident - The unique identifier of the aircraft to retrieve.
 * @returns {Aircraft|null} The aircraft object with the matching identifier, or undefined if not found.
 */
function useAircraft(ident) {
	const fleetMap = useSelector(state => state.fleet);
	const staff = useSelector(state => state.staff);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const aircraft = useMemo(() => fleetMap.get(ident), [ident, fleetMap, staff]);
	return aircraft;
}

export default useAircraft;
